import React, { useEffect } from 'react';
import { useAutoTranslation } from '../hooks/useAutoTranslation';

interface AutoTranslateWrapperProps {
  children: React.ReactNode;
}

const AutoTranslateWrapper: React.FC<AutoTranslateWrapperProps> = ({ children }) => {
  const { currentLanguage, supportedLanguages } = useAutoTranslation();

  useEffect(() => {
    //console.log('🌍 AutoTranslateWrapper - Langue active:', currentLanguage);
    
    // Ajouter une classe CSS pour indiquer la langue
    document.documentElement.setAttribute('lang', currentLanguage);
    document.documentElement.setAttribute('data-translate-lang', currentLanguage);
    
  }, [currentLanguage]);

  return <>{children}</>;
};

export default AutoTranslateWrapper;